import { Dispatch } from "redux";
import api from ".";

import { getProfile } from "../Action/resturantProfile.action";
import { displayLoader } from "../Action/loader.action";

export const getProfileApi = (slug: any, zone: any) => (dispatch: Dispatch) => {
    api.get(`/profile/${slug}?zone=${zone ?? "dine-in"}`)
        .then((response) => {
            dispatch(displayLoader(false));
            dispatch(getProfile(response.data));
        })
        .catch((err) => {
            dispatch(displayLoader(false));
        });
};
